import { bindActionCreators } from 'redux';
import { connect } from '../../../../react-redux';
import { openDeleteStimulusModal } from '../../../../actions/modal';
import { set } from '../../../../actions/ui';
import { featureOn } from '../../../../../common/util/featureCheck';
import WrappedStimulus from './presenter';
var mapStateToProps = function mapStateToProps(state, props) {
  var dndPosition = state.getIn(['dragAndDrop', 'position']);
  var draggingAboveHalf = state.getIn(['dragAndDrop', 'aboveHalf'], false);
  var dropIntoEmptyStimulus = state.getIn(['dragAndDrop', 'intoEmptyStimulus']);
  var draggingOver = props.draggingOnBuild && dndPosition === props.quizEntry.position;
  return {
    childEntries: props.quizEntry.getNestedEntries(),
    dropIntoEmptyStimulus: draggingOver && dropIntoEmptyStimulus,
    draggingOver: draggingOver,
    draggingAboveHalf: draggingOver && draggingAboveHalf,
    lockBlueprintContentEnabled: featureOn('lock_blueprint_content'),
    stimulusOrientationEnabled: featureOn('customizable_stimulus_orientation')
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openDeleteStimulusModal: bindActionCreators(openDeleteStimulusModal, dispatch),
    setUi: bindActionCreators(set, dispatch)
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(WrappedStimulus);